// extracted by mini-css-extract-plugin
export default {"content":"LoginPage_content__u-v0B"};